
export class Decoder {
/**
 * @param {?} blob
 * @param {?} actx
 * @return {?}
 */
public static decode(blob: Blob | File, actx: AudioContext): Promise<AudioBuffer> {
    return new Promise<AudioBuffer>((resolve, reject) => {
      const /** @type {?} */ reader = new FileReader;
      reader.onloadend = () => {
        actx.decodeAudioData(reader.result).then(resolve, reject);
      };
      reader.onerror = reject;
      reader.onabort = reject;
      reader.readAsArrayBuffer(blob);
    });
  }
}
